import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/ProfitAndLoss/AccountingReportProfitandLossAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingReportProfitandLossActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/ProfitAndLoss/AccountingReportProfitandLoss")
	}

	render() {
		return (
			<Activity 
				name="AccountingReportProfitandLoss"
				RenderedComponent={this.RenderedComponent}
				context="AccountingReportProfitandLoss"
				action="AccountingReportProfitandLoss"
				formActions={FormAction}			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingReportProfitandLossActivity)
